import { render, staticRenderFns } from "./PriceSuggestions.vue?vue&type=template&id=56f6dee0&"
import script from "./PriceSuggestions.vue?vue&type=script&lang=js&"
export * from "./PriceSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports